// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__nvkcQ","spinner":"styles_spinner__lsBoz","rotation":"styles_rotation__FDWHr"};